import React from 'react';
import Icon from '@pushpay/icon';

const ResourceIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 13.667h-2.917A.834.834 0 0017 14.5c0 .46-.373.833-.833.833H7.833A.834.834 0 017 14.5a.834.834 0 00-.833-.833H3.25c-.69 0-1.25.56-1.25 1.25v5.416C2 21.254 2.746 22 3.667 22h16.666c.921 0 1.667-.746 1.667-1.667v-5.416c0-.69-.56-1.25-1.25-1.25zM9.917 12a.834.834 0 000 1.667h4.166a.834.834 0 000-1.667H9.917zm-5.834-.833c.46 0 .834-.374.834-.834h14.166a.834.834 0 001.667 0c0-.92-.746-1.666-1.667-1.666H4.917c-.921 0-1.667.745-1.667 1.666 0 .46.373.834.833.834zm0-3.334c.46 0 .834-.373.834-.833h14.166a.834.834 0 001.667 0c0-.92-.746-1.667-1.667-1.667H4.917C3.996 5.333 3.25 6.08 3.25 7c0 .46.373.833.833.833zm0-3.333c.46 0 .834-.373.834-.833h14.166a.834.834 0 001.667 0c0-.921-.746-1.667-1.667-1.667H4.917c-.921 0-1.667.746-1.667 1.667 0 .46.373.833.833.833z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

export default ResourceIcon;